module.exports = {"title":"Forgot your password?","content":"Please enter your username and an email to reset your password will be sent to you.","username":"Username","forgotUsername":"Forgot your username?","submit":"Submit","msg":{"yay":"Yay!","oops":"Oops!","success":"Email sent successfully, please check your inbox"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/ForgotPassword/locales/en.json
// module id = 1762
// module chunks = 0